import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  GetProductCategoryListDropDownSlice,
  GetProductCategorySlice,
  GetSubCategoryProductSlice,
} from "../../../redux/features/ProductCategorySlice";
import {
  CreateProductCatalogueSlice,
  DeleteCustomizeProductListSlice,
  GetCustomizeProductListSlice,
} from "../../../redux/features/ProductCatalogueSlice";
import { IoMdClose } from "react-icons/io";
import ReactMultiSelectCheckboxes from "react-multiselect-checkboxes";
import { GetCityManagementSlice } from "../../../redux/features/CityManagementSlice";
import { useNavigate } from "react-router-dom";
import { FaEdit, FaRegStar, FaStar } from "react-icons/fa";
import { MdDelete } from "react-icons/md";
import { onImageHandler } from "../../../components/UploadImageOnBucket";
import ButtonSpinner from "../../../common/Loader/ButtonSpinner";
import { toast } from "react-toastify";
import Editor from "../../../common/Editor/Editor";
import AddCustomizeProduct from "./AddCustomizeProduct";
import EditCustomizeProduct from "./EditCustomizeProduct";
import { CiViewList } from "react-icons/ci";
import ViewCustomizeProduct from "./ViewCustomizeProduct";

const AddProductCatalogue = () => {
  const dispatch = useDispatch();
  const [showModal, setShowModal] = useState({
    add: false,
    edit: false,
    view: false,
  });
  const [dataForHold, setDataForHold] = useState();
  const [CustomizeProduct, setCustomizeProduct] = useState([]);
  const [selectedForProduct, setSelectedForProduct] = useState({});
  const [dataForSendToApi, setDataForSendToApi] = useState({
    productDetails: {
      productcategory: "",
      productsubcategory: "",
      productname: "",
      producttitledescription: "",
      estimatedecorativetime: "",
    },
    priceDetails: {
      price: "",
      gstslab: "",
      discountedPrice:""
    },
    productdescription: {
      inclusion: [],
      aboutexperience: "",
      need: "",
      cancellation: "",
    },
    productcustomizeDetails: {
      description: "",
    },
    availableCities: {
      cityName: "",
    },
  });

  const [productImages, setProductImages] = useState([]);
  const [customImages, setCustomImages] = useState([]);
  const [SelectedOptions, setSelectedOptions] = useState();
  const [AllCities, setAllCities] = useState();
  const [CityManagement, setCityManagement] = useState([]);
  const [check, setCheck] = useState([]);

  const [customObj, setCustomeObj] = useState([]);

  const { loading, EditCustomizeProductList, CreatedCustomizeProduct } =
    useSelector((state) => state.ProductCatalogue);

  // const handleCreareField = () => {
  //   const len = Math.round(Math.random() * 10000);
  //   setCustomeObj((prev) => [
  //     ...prev,
  //     { id: len, ProductName: "", ProductPrice: "", ProductImage: "" },
  //   ]);
  // };

  // const handleCustomObjChange = ({ index, id, e }) => {
  //   const tempObj = Object.assign({}, customObj);

  //   tempObj[index][e.target.name] = e.target.value;

  //   const ArrTemp = Object.entries(tempObj).map(([index, item]) => item);

  //   // console.log(ArrTemp);
  //   setCustomeObj(() => ArrTemp);
  // };

  const navigate = useNavigate(); 

  const [data, setData] = useState({
    categoryList: "",
    subcategoryList: "",
  });

  useEffect(() => {
    dispatch(GetProductCategoryListDropDownSlice()).then((res) => {
      // console.log("dataa:",res.payload.data);
      setData((prev) => ({
        ...prev,
        categoryList: res?.payload?.data,
      }));
    });
    dispatch(GetCityManagementSlice()).then((res) => {
      setCityManagement(res?.payload?.data);
    });
  }, []);

  useEffect(() => {
    console.log("11:", selectedForProduct["productcategory"]);
    if (selectedForProduct["productcategory"]) {
      dispatch(
        GetSubCategoryProductSlice(selectedForProduct["productcategory"])
      ).then((res) => {
        const dummyData = res?.payload?.data?.subcategory;
        // console.log("dummydata:",dummyData);
        setData((prev) => ({ ...prev, subcategoryList: dummyData }));
      });
    }
  }, [selectedForProduct["productcategory"]]);

  const handleChange = (e, parentKey) => {
    const { name, value } = e.target;
    // console.log("name:",name,"value:",value);
    setDataForSendToApi((prev) => ({
      ...prev,
      [parentKey]: {
        ...prev[parentKey],
        [name]: value,
      },
    }));
  };

  const handleImage = async (e) => {
    const { name, files } = e.target;
    try {
      if (files[0] === undefined) return;

      const data = await onImageHandler(e);

      if (name === "productimages") {
        const len = productImages?.length;

        setProductImages((prev) => [...prev, data[1].location]);
      } else {
        const len = customImages?.length;

        setCustomImages((prev) => [...prev, data[1].location]);
      }
    } catch (error) {
      //  console.log('error:',error)
      toast.error("Something went worng while uploading picture on bucket!");
    }
  };

  function handleRemove(selectedItem) {
    const filterData = productImages?.filter(
      (value, index) => index !== selectedItem
    );
    setProductImages(filterData);
  }

  useEffect(() => {
    if (Array.isArray(CityManagement?.cities)) {
      const dataForCity = CityManagement?.cities?.map((data) => ({
        label: data.cityName,
        value: data.cityName,
      }));
      setAllCities(dataForCity);
    }
  }, [CityManagement]);

  const handleMultiSelectChange = (selected, parentKey) => {
    setDataForSendToApi((prev) => ({
      ...prev,
      [parentKey]: {
        cityName: selected.map((option) => option.value).join(", "),
      },
    }));

    setSelectedOptions(selected);
  };

  const handleSubmit = () => {
    // console.log("dataForSendToApi:", dataForSendToApi);

    const formData = new FormData();

    console.log(dataForSendToApi.productDetails);
    const Productdetail = dataForSendToApi.productDetails;

    if (!Productdetail?.productname?.length) {
      toast.error("Please fill product name!");
      return;
    }

    if (!Productdetail?.productcategory?.length) {
      toast.error("Please select category!");
      return;
    }

    if (!Productdetail?.productsubcategory?.length) {
      toast.error("Please select sub category!");
      return;
    }

    if (!dataForSendToApi.availableCities.cityName?.length > 0) {
      toast.error("Please Please select City!");
      return;
    }

    if (!Productdetail?.estimatedecorativetime?.length) {
      toast.error("Please fill estimated Decoration time!");
      return;
    }

    console.log(dataForSendToApi.priceDetails);

    if (!dataForSendToApi.priceDetails?.gstslab?.length) {
      toast.error("please Fill GST % details");
      return false;
    }

    const ProductDesc = dataForSendToApi.productdescription;

    if (!ProductDesc?.aboutexperience.length) {
      toast.error("Please Please fill about experience details!");
      return;
    }
    if (!ProductDesc?.cancellation?.length) {
      toast.error("Please Please fill cancellation details!");
      return;
    }

    if (!ProductDesc?.inclusion?.length) {
      toast.error("Please Please fill inclusion details!");
      return;
    }

    if (Object.entries(productImages)?.length === 0) {
      toast.error("Please select product images!");
      return;
    }

    const ParseEstimatedDecorTime = Object.fromEntries(
      Object.entries(dataForSendToApi.productDetails).map(
        ([key, value], index) => {
          if (key === "estimatedecorativetime") return [key, Number(value)];
          else return [key, value];
        }
      )
    );

    // console.log("**:",ParseEstimatedDecorTime);

    // Add productDetails as a JSON string
    formData.append("productDetails", JSON.stringify(ParseEstimatedDecorTime));

    // Add priceDetails as a JSON string
    formData.append(
      "priceDetails",
      JSON.stringify(dataForSendToApi.priceDetails)
    );

    // Add productdescription as a JSON string
    formData.append(
      "productdescription",
      JSON.stringify(dataForSendToApi.productdescription)
    );

    // Add availableCities as an array of city names
    formData.append(
      "availableCities",
      dataForSendToApi.availableCities.cityName
    );

    // Add productImages as files
    Array.from(productImages).forEach((file) => {
      formData.append("productimages", file);
    });

    // Add productcustomizeDetails as JSON
    formData.append(
      "productcustomizeDetails",
      JSON.stringify(
        customObj?.map((custom) => ({
          name: custom?.name,
          price: custom?.price,
          customImages: custom?.customimage,
          description: custom?.description,
          customproductId: custom?._id,
        }))
      )
    );

    dispatch(CreateProductCatalogueSlice(formData)).then((res) => {
      console.log(res.payload.data);
      if (Object.entries(res.payload.data ?? {})?.length > 0) {
        navigate(-1);
      }
    });
  };

  useEffect(() => {
    dispatch(GetCustomizeProductListSlice()).then((res) => {
      setCustomizeProduct(res?.payload?.data);
    });
  }, [EditCustomizeProductList, CreatedCustomizeProduct]);

  const handleDeleteCustomizeProduct = () => {
    dispatch(DeleteCustomizeProductListSlice(dataForHold)).then((res) => {
      dispatch(GetCustomizeProductListSlice()).then((res) => {
        setCustomizeProduct(res?.payload?.data);
      });
    });
  };

  const handleSortThumnnail=(element)=>{
    console.log('call',element)
      const images = [...productImages]?.sort((a, b) => {
        if (a === element) return -1; // a comes before b
        if (b === element) return 1;  // b comes before a
        return 0;                     // keep original order for others
      });

      console.log(images);
      setProductImages(images);
  }

  return (
    <>
      <>
        <div className="WrapperArea">
          <div className="WrapperBox">
            <div className="Small-Wrapper">
              <div className="row">
                <div className="col-sm-12">
                  <div
                    style={{
                      width: "100%",
                      display: "flex",
                      justifyContent: "space-between",
                      alignItems: "center",
                    }}
                  >
                    <div className="TitleBox">
                      <h2>Product Information</h2>
                    </div>
                    <div>
                      {/* <button type="button" onClick={()=>setShowModal((prev)=>!prev)} className="Button" id="ProductCustomize" data-toggle="modal" data-target=".bd-example-modal-lg">Add Customize Product</button> */}
                      <button
                        className="Button"
                        data-toggle="modal"
                        data-target="#ProductCustomize"
                        onClick={() =>
                          setShowModal((prev) => ({
                            ...prev,
                            add: !prev["add"],
                          }))
                        }
                      >
                        Add Customize Product
                      </button>
                    </div>
                  </div>
                  <div className="ItineraryArea">
                    <div className="row">
                      <div className="col-sm-6">
                        <div className="form-group">
                          <label>Product Category</label>
                          <select
                            className="form-control"
                            name="productcategory"
                            onChange={(e) => {
                              setSelectedForProduct((prev) => ({
                                ...prev,
                                [e.target.name]:
                                  e.target.options[e.target.selectedIndex]
                                    .dataset.key,
                              }));
                              handleChange(e, "productDetails");
                            }}
                          >
                            <option>--Select</option>
                            {Array.isArray(data?.categoryList) &&
                              data?.categoryList?.length &&
                              data?.categoryList?.map((item, index) => {
                                return (
                                  <option
                                    value={item?.categoryName}
                                    data-key={item?._id}
                                  >
                                    {item?.categoryName}
                                  </option>
                                );
                              })}
                          </select>
                        </div>
                      </div>
                      <div className="col-sm-6">
                        <div className="form-group">
                          <label>Product Sub-Category</label>
                          <select
                            className="form-control"
                            name="productsubcategory"
                            onChange={(e) => {
                              handleChange(e, "productDetails");
                            }}
                          >
                            <option>--Select</option>
                            {Array.isArray(data?.subcategoryList) &&
                              data?.subcategoryList?.length &&
                              data?.subcategoryList?.map((item, index) => {
                                return (
                                  <option value={item?.subcategoryName}>
                                    {item?.subcategoryName}
                                  </option>
                                );
                              })}
                          </select>
                        </div>
                      </div>
                      <div className="col-sm-6">
                        <div className="form-group">
                          <label>Title/Name of Product</label>
                          <input
                            type="text"
                            className="form-control"
                            name="productname"
                            onChange={(e) => {
                              handleChange(e, "productDetails");
                            }}
                          />
                        </div>
                        <div className="form-group">
                          <label>Estimate Decorator Time(Hours)</label>
                          <input
                            type="text"
                            className="form-control"
                            name="estimatedecorativetime"
                            value={
                              dataForSendToApi?.productDetails
                                ?.estimatedecorativetime
                            }
                            onChange={(e) => {
                              const regex = /^(\d{1,2})?$/;
                              if (regex.test(e.target.value))
                                handleChange(e, "productDetails");
                            }}
                          />
                        </div>
                      </div>
                      <div className="col-sm-6">
                        <div className="form-group">
                          <label>City</label>
                          <ReactMultiSelectCheckboxes
                            options={AllCities}
                            value={SelectedOptions}
                            onChange={(e) =>
                              handleMultiSelectChange(e, "availableCities")
                            }
                          />
                        </div>
                        {/* <div className="form-group">
                          <label>Product Title Description</label>
                          <textarea
                            className="form-control"
                            placeholder="write here.."
                            rows={1}
                            defaultValue={""}
                            name="producttitledescription"
                            onChange={(e) => handleChange(e, "productDetails")}
                          />
                        <Editor setContentState={setDataForSendToApi} type={'DataTitleDesc'} dataForSendToApi={dataForSendToApi} content={dataForSendToApi?.productDetails?.producttitledescription}/>
                        </div> */}
                      </div>
                      <div className="col-sm-12">
                        <div className="form-group">
                          <label>Product Title Description</label>
                          <Editor
                            setContentState={setDataForSendToApi}
                            type={"DataTitleDesc"}
                            dataForSendToApi={dataForSendToApi}
                            content={
                              dataForSendToApi?.productDetails
                                ?.producttitledescription
                            }
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="Small-Wrapper">
              <div className="TitleBox">
                <h2>Price Details</h2>
              </div>
              <div className="ItineraryArea">
                <div className="row">
                  <div className="col-sm-4">
                    <div className="form-group">
                      <label>Actual Price</label>
                      <input
                        type="text"
                        className="form-control"
                        name="price"
                        onChange={(e) => handleChange(e, "priceDetails")}
                      />
                    </div>
                  </div>
                  <div className="col-sm-4">
                    <div className="form-group">
                      <label>Discounted Price</label>
                      <input
                        type="text"
                        className="form-control"
                        name="discountedPrice"
                        onChange={(e) => handleChange(e,"priceDetails")} 
                      />
                    </div>
                  </div>
                  <div className="col-sm-4">
                    <div className="form-group">
                      <label>GST Slab</label>
                      <select
                        className="form-control"
                        name="gstslab"
                        onChange={(e) => handleChange(e, "priceDetails")}
                      >
                        <option selected="">--select--</option>
                        <option>18%</option>
                      </select>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="Small-Wrapper">
              <div className="TitleBox">
                <h2>Product Description</h2>
              </div>
              <div className="NewCommonTabs">
                <ul className="nav nav-tabs">
                  <li className="nav-item">
                    <a
                      className="nav-link active"
                      data-toggle="tab"
                      href="#Inclusion"
                    >
                      Inclusion
                    </a>
                  </li>
                  <li className="nav-item">
                    <a
                      className="nav-link"
                      data-toggle="tab"
                      href="#AboutTheExperience"
                    >
                      About The Experience
                    </a>
                  </li>
                  <li className="nav-item">
                    <a
                      className="nav-link"
                      data-toggle="tab"
                      href="#NeedToKnow"
                    >
                      Need To Know
                    </a>
                  </li>
                  <li className="nav-item">
                    <a
                      className="nav-link"
                      data-toggle="tab"
                      href="#CancellationPolicy"
                    >
                      Cancellation Policy
                    </a>
                  </li>
                </ul>
              </div>
              <div className="tab-content mb-4">
                <div className="tab-pane fade active show" id="Inclusion">
                  <aside className="file-info-checkbox">
                    <h4
                      style={{
                        fontSize: 16,
                        fontWeight: 600,
                        color: "#000",
                        margin: "10px 0 20px",
                      }}
                    >
                      Inclusion
                    </h4>
                    <Editor
                      setContentState={setDataForSendToApi}
                      type={"DataInclusion"}
                      dataForSendToApi={dataForSendToApi}
                      content={
                        dataForSendToApi?.productdescription?.inclusion?.[0]
                      }
                    />
                  </aside>
                </div>
                <div className="tab-pane fade" id="AboutTheExperience">
                  <div className="ItineraryArea">
                    <div className="form-group">
                      <label>About The Experience</label>
                      <Editor
                        setContentState={setDataForSendToApi}
                        type={"DataExperience"}
                        dataForSendToApi={dataForSendToApi}
                        content={
                          dataForSendToApi?.productdescription?.aboutexperience
                        }
                      />
                    </div>
                  </div>
                </div>
                <div className="tab-pane fade" id="NeedToKnow">
                  <div className="ItineraryArea">
                    <div className="row">
                      <div className="col-sm-12">
                        <div className="form-group">
                          <label>Need To Know</label>
                          <Editor
                            setContentState={setDataForSendToApi}
                            type={"DataNeedToKnow"}
                            dataForSendToApi={dataForSendToApi}
                            content={dataForSendToApi?.productdescription?.need}
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="tab-pane fade" id="CancellationPolicy">
                  <div className="ItineraryArea">
                    <div className="row">
                      <div className="col-sm-12">
                        <div className="form-group">
                          <label>Cancellation Policy</label>
                          <Editor
                            setContentState={setDataForSendToApi}
                            type={"DataForCancellation"}
                            dataForSendToApi={dataForSendToApi}
                            content={
                              dataForSendToApi?.productdescription?.cancellation
                            }
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="Small-Wrapper">
              <div className="TitleBox">
                <h2>Product Images</h2>
              </div>
              <div className="row">
                <div className="col-sm-12">
                  <div className="ItineraryArea">
                    <div className="row">
                      <div className="col-sm-4">
                        <div className="form-group">
                          <label>Upload Images</label>
                          <div className="UploadBox">
                            <div className="Upload">
                              <i className="fa fa-upload" /> <span>Upload</span>
                              <input
                                type="file"
                                multiple
                                name="productimages"
                                onChange={handleImage}
                              />
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className="col-md-12">
                        <div className="ProductImages ProfileBox2">
                          {productImages?.map((value, index) => {
                            return (
                              <div
                                style={{
                                  border: "10px solid whitesmoke",
                                  width: "220px",
                                  position: "relative",
                                }}
                              >
                                <div style={{width:'200px',height:'200px'}}>
                                <img
                                  src={value}
                                  style={{
                                    height: "100%",
                                    width: "100%",
                                    objectFit: "cover",
                                  }}
                                  key={index}
                                  alt=""
                                />
                                </div>
                                <IoMdClose
                                  style={{
                                    border: "2px solid",
                                    borderRadius: "20px",
                                    position: "absolute",
                                    cursor: "pointer",
                                    fontSize: "22px",
                                    right:'-20',
                                    top: "-20px",
                                    color: "black",
                                  }}
                                  //  className="fa fa-times"
                                  aria-hidden="true"
                                  onClick={() => handleRemove(index)}
                                />
                                <div
                                onClick={()=>handleSortThumnnail(value)}
                                >
                                {index === 0 ?
                                  <FaStar
                                    style={{
                                      cursor:'pointer',
                                      fill:'gold',
                                      position:'absolute',
                                      bottom:'0px',
                                      color: "gold",
                                      fontSize: "23px",
                                      marginLeft: "5px",
                                      marginBottom: "5px",
                                    }}
                                    title="Select For thumbnail"
                                  />
                                  :
                                  <FaRegStar
                                    style={{
                                      cursor:'pointer',
                                      fill:'gold',
                                      position:'absolute',
                                      bottom:'0px',
                                      color: "gold",
                                      fontSize: "23px",
                                      marginLeft: "5px",
                                      marginBottom: "5px",
                                    }}
                                    title="Select For thumbnail"
                                  />
                                  }
                                </div>
                              </div>
                            );
                          })}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="Small-Wrapper">
              <div className="TitleBox">
                <h2>Please Select Product Customization</h2>
              </div>
              <div className="row">
                <div className="col-sm-12">
                  <div className="ItineraryArea" style={{ border: "none" }}>
                    <div className="row">
                      {/* <div className="" style={{ paddingLeft: "20px" }}>
                        <>
                          {customObj?.map((item, index) => {
                            return (
                              <div
                                style={{
                                  minWidth: "100%",
                                  display: "flex",
                                  flexDirection: "column",
                                  gap: "10px",
                                  marginBottom: "20px",
                                  border: "1px solid lightgray",
                                  padding: "10px",
                                  borderRadius: "10px",
                                  position: "relative",
                                }}
                              >
                                <a
                                  onClick={() => handleRemoveProduct(item.id)}
                                  href="javascript:void(0);"
                                  className="CloseModal"
                                  data-dismiss="modal"
                                  style={{
                                    display: "flex",
                                    justifyContent: "center",
                                    alignItems: "center",
                                    position: "absolute",
                                    top: "-15px",
                                    right: "-10px",
                                    height: "20px",
                                    width: "20px",
                                    borderRadius: "100%",
                                    backgroundColor: "lightgray",
                                  }}
                                >
                                  <IoMdClose
                                    color="black"
                                    style={{ margin: "0 auto" }}
                                  />
                                </a>
                                <div
                                  key={index}
                                  style={{ display: "flex", gap: "10px" }}
                                >
                                  <div>
                                    <p
                                      style={{
                                        textTransform: "capitalize",
                                        color: "#000",
                                        fontSize: "14px",
                                        fontWeight: "700",
                                      }}
                                    >
                                      Product Name
                                    </p>
                                    <input
                                      type="text"
                                      class="form-control"
                                      value={item["ProductName"]}
                                      name="ProductName"
                                      onChange={(e) =>
                                        handleCustomObjChange({
                                          index,
                                          id: item?.id,
                                          e,
                                        })
                                      }
                                    />
                                  </div>
                                  <div>
                                    <p
                                      style={{
                                        textTransform: "capitalize",
                                        color: "#000",
                                        fontSize: "14px",
                                        fontWeight: "700",
                                      }}
                                    >
                                      Product Price
                                    </p>
                                    <input
                                      type="text"
                                      class="form-control"
                                      value={item["ProductPrice"]}
                                      name="ProductPrice"
                                      onChange={(e) =>
                                        handleCustomObjChange({
                                          index,
                                          id: item?.id,
                                          e,
                                        })
                                      }
                                    />
                                  </div>
                                  <div>
                                    <p
                                      style={{
                                        textTransform: "capitalize",
                                        color: "#000",
                                        fontSize: "14px",
                                        fontWeight: "700",
                                      }}
                                    >
                                      Product Image
                                    </p>
                                    <div
                                      style={{
                                        position: "relative",
                                        width: "100px",
                                        height: "60px",
                                        border: "2px dotted grey",
                                        backgroundColor: "#6e60601c",
                                      }}
                                    >
                                      {item["ProductImage"]?.length > 0 ? (
                                        <div>
                                          <img
                                            src={item["ProductImage"]}
                                            style={{
                                              height: "60px",
                                              width: "100px",
                                            }}
                                            alt=""
                                            srcset=""
                                          />
                                          <div
                                            style={{
                                              height: "20px",
                                              cursor: "pointer",
                                              width: "20px",
                                              position: "relative",
                                              left: "85%",
                                              bottom: "60px",
                                            }}
                                          >
                                            <input
                                              type="file"
                                              style={{
                                                height: "100%",
                                                width: "100%",
                                                opacity: "0",
                                                zIndex: "100",
                                                position: "absolute",
                                              }}
                                              name="ProductImage"
                                              onChange={(e) =>
                                                handleCustomObjChangeImage({
                                                  index,
                                                  id: item?.id,
                                                  e,
                                                })
                                              }
                                            />
                                            <TbEditCircle
                                              style={{
                                                fontSize: "15px",
                                                color: "black",
                                                position: "absolute",
                                              }}
                                            />
                                          </div>
                                        </div>
                                      ) : (
                                        <>
                                          <input
                                            type="file"
                                            class="form-control"
                                            accept=".png,.jpg,.jpeg"
                                            style={{
                                              width: "100%",
                                              cursor: "pointer",
                                              zIndex: "100",
                                              height: "100%",
                                              opacity: "0",
                                              position: "absolute",
                                            }}
                                            name="ProductImage"
                                            onChange={(e) =>
                                              handleCustomObjChangeImage({
                                                index,
                                                id: item?.id,
                                                e,
                                              })
                                            }
                                          />
                                          <FaCloudDownloadAlt
                                            style={{
                                              fontSize: "40px",
                                              position: "absolute",
                                              left: "30%",
                                              top: "10%",
                                            }}
                                          />
                                        </>
                                      )}
                                    </div>
                                  </div>
                                </div>
                              </div>
                            );
                          })}
                        </>
                        <button
                          type="button"
                          onClick={handleCreareField}
                          style={{
                            width: "100%",
                            border: "none",
                            margin: "10px 0",
                            color: "white",
                            padding: "10px",
                            borderRadius: "5px",
                            backgroundImage:
                              "linear-gradient(45deg, #af1ff3, #bf4ef4",
                          }}
                        >
                          Add Customize product
                        </button>
                      </div> */}
                      <div
                        className="ProductImages ProfileBox2"
                        style={{
                          display: "flex",
                          flexDirection: "column",
                          maxHeight: "800px",
                          overflow: "scroll",
                        }}
                      >
                        {CustomizeProduct?.map((item, key) => {
                          return (
                            <div
                              style={{
                                minWidth: "100%",
                                display: "flex",
                                flexDirection: "column",
                                cursor: "pointer",
                                gap: "10px",
                                marginBottom: "20px",
                                border: "1px solid lightgray",
                                padding: "10px",
                                borderRadius: "10px",
                                position: "relative",
                                backgroundColor: `${
                                  customObj.some(
                                    (temp, index) => temp?._id === item?._id
                                  )
                                    ? "#b93df4"
                                    : "white"
                                }`,
                                color: `${
                                  customObj.some(
                                    (temp, index) => temp?._id === item?._id
                                  )
                                    ? "white"
                                    : "black"
                                }`,
                              }}
                            >
                              <div
                                style={{
                                  position: "absolute",
                                  right: "0",
                                  top: "-13px",
                                  display: "flex",
                                  gap: "7px",
                                }}
                              >
                                <div
                                  data-toggle="modal"
                                  data-target="#EditProductCustomize"
                                  onClick={() => {
                                    setDataForHold(item);
                                    setShowModal((prev) => ({
                                      ...prev,
                                      view: !prev["view"],
                                    }));
                                  }}
                                  style={{
                                    height: "25px",
                                    width: "25px",
                                    borderRadius: "100%",
                                    backgroundColor: "silver",
                                    display: "flex",
                                    justifyContent: "center",
                                    alignItems: "center",
                                  }}
                                >
                                  <CiViewList fontSize={"17px"} color="blue" />
                                </div>
                                <div
                                  data-toggle="modal"
                                  data-target="#EditProductCustomize"
                                  onClick={() => {
                                    setDataForHold(item);
                                    setShowModal((prev) => ({
                                      ...prev,
                                      edit: !prev["edit"],
                                    }));
                                  }}
                                  style={{
                                    height: "25px",
                                    width: "25px",
                                    borderRadius: "100%",
                                    backgroundColor: "silver",
                                    display: "flex",
                                    justifyContent: "center",
                                    alignItems: "center",
                                  }}
                                >
                                  <FaEdit fontSize={"17px"} color="green" />
                                </div>
                                <div
                                  onClick={() => setDataForHold(item?._id)}
                                  style={{
                                    height: "25px",
                                    width: "25px",
                                    borderRadius: "100%",
                                    backgroundColor: "silver",
                                    display: "flex",
                                    justifyContent: "center",
                                    alignItems: "center",
                                  }}
                                >
                                  <MdDelete
                                    className="Red"
                                    data-toggle="modal"
                                    data-target="#DeleteModal"
                                    fontSize={"20px"}
                                    color="red"
                                  />
                                </div>
                              </div>
                              <div
                                key={key}
                                style={{
                                  display: "flex",
                                  gap: "10px",
                                  justifyContent: "space-around",
                                }}
                                onClick={() =>
                                  setCustomeObj((prev) => {
                                    if (
                                      customObj.some(
                                        (data, index) =>
                                          data?.name === item?.name
                                      )
                                    ) {
                                      return customObj.filter(
                                        (dataItem, i) =>
                                          dataItem?.name !== item?.name
                                      );
                                    }
                                    return [...prev, item];
                                  })
                                }
                              >
                                <div>
                                  <p
                                    style={{
                                      textTransform: "capitalize",
                                      // color: "#000",
                                      fontSize: "14px",
                                      fontWeight: "700",
                                    }}
                                  >
                                    Product Name
                                  </p>
                                  <input
                                    type="text"
                                    class="form-control"
                                    disabled={true}
                                    value={item["name"]}
                                    name="name"
                                  />
                                </div>
                                <div>
                                  <p
                                    style={{
                                      textTransform: "capitalize",
                                      // color: "#000",
                                      fontSize: "14px",
                                      fontWeight: "700",
                                    }}
                                  >
                                    Product Price
                                  </p>
                                  <input
                                    type="text"
                                    class="form-control"
                                    disabled={true}
                                    value={item["price"]}
                                    name="ProductPrice"
                                  />
                                </div>
                                <div>
                                  <p
                                    style={{
                                      textTransform: "capitalize",
                                      // color: "#000",
                                      fontSize: "14px",
                                      fontWeight: "700",
                                    }}
                                  >
                                    Product description
                                  </p>
                                  <div>
                                    <div
                                      dangerouslySetInnerHTML={{
                                        __html: `${item?.description?.slice(
                                          0,
                                          20
                                        )}...`,
                                      }}
                                    />
                                    <div />
                                  </div>
                                </div>
                                <div>
                                  <p
                                    style={{
                                      textTransform: "capitalize",
                                      // color: "#000",
                                      fontSize: "14px",
                                      fontWeight: "700",
                                    }}
                                  >
                                    Product Image
                                  </p>
                                  <div
                                    style={{
                                      position: "relative",
                                      width: "100px",
                                      height: "60px",
                                      border: "2px dotted grey",
                                      backgroundColor: "#6e60601c",
                                    }}
                                  >
                                    <div>
                                      <img
                                        src={item["customimage"]}
                                        style={{
                                          height: "60px",
                                          width: "100px",
                                        }}
                                        alt="Loading from Bucket"
                                        srcset=""
                                      />
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          );
                        })}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <button
              disabled={loading}
              onClick={handleSubmit}
              className="Button"
            >
              {loading ? <ButtonSpinner /> : "Add"}
            </button>
          </div>
        </div>
        {showModal?.add && (
          <AddCustomizeProduct
            showModal={showModal?.add}
            setShowModal={setShowModal}
          />
        )}
        {showModal?.edit && (
          <EditCustomizeProduct
            data={dataForHold}
            showModal={showModal?.edit}
            setShowModal={setShowModal}
          />
        )}
        {showModal?.view && (
          <ViewCustomizeProduct
            data={dataForHold}
            showModal={showModal?.edit}
            setShowModal={setShowModal}
          />
        )}

        <div className="ModalBox">
          <div id="DeleteModal" className="modal fade" role="dialog">
            <div className="modal-dialog">
              <div className="modal-content">
                <div className="modal-body">
                  <div className="Decline">
                    <a
                      href="javascript:void(0);"
                      className="CloseModal"
                      data-dismiss="modal"
                    >
                      ×
                    </a>
                    <h3>Delete</h3>
                    <p>Are you sure you want to Delete? </p>
                    <h4>
                      <a href="javascript:void(0);" data-dismiss="modal">
                        no
                      </a>
                      <a
                        onClick={handleDeleteCustomizeProduct}
                        href="javascript:void(0);"
                        data-dismiss="modal"
                      >
                        Yes
                      </a>
                    </h4>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </>
    </>
  );
};

export default AddProductCatalogue;
